import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Heading, Flex, Button, Box, Text, useToast } from "@chakra-ui/react";
import SingleCard from "../components/SingleCard";
import CommonVars from "../components/CommonVars";
import axios from "axios";

// make the cards array
const cardImages = [
    { "src": "/img/memory1.png", matched: false },
    { "src": "/img/memory2.png", matched: false },
    { "src": "/img/memory3.png", matched: false },
    { "src": "/img/memory4.png", matched: false },
    { "src": "/img/memory5.png", matched: false },
    { "src": "/img/memory6.png", matched: false },
];

// let given discount code be false initially
let givenCode = false;

function MemoryGameScreen() {
    if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')) === null) {
        window.location.replace("/unauthorized");
    }
    const userid = parseInt(useParams().userid);
    const theToken = localStorage.getItem('token');
    const [cards, setCards] = useState([]);
    const [turns, setTurns] = useState(0);
    const [choiceOne, setChoiceOne] = useState(null);
    const [choiceTwo, setChoiceTwo] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [count, setCount] = useState(0);

    // set logout toast message
    const gameToast = useToast();
    const id = 'game-toast';

    // shuffle the cards
    const shuffleCards = () => {
        // take the objects in cardImage, duplicate and put in array
        const shuffledCards = [...cardImages, ...cardImages]
              .sort(() => Math.random() - 0.5)
              .map((card) => ({ ...card, id: Math.random() }));

              setChoiceOne(null);
              setChoiceTwo(null);
              // update the states
              setCards(shuffledCards);
              setTurns(0)
    }

    // when restart game button is clicked, reload page then shuffle cards
    const shuffleCardsReload = () => {
        window.location.reload();
        const shuffledCards = [...cardImages, ...cardImages]
              .sort(() => Math.random() - 0.5)
              .map((card) => ({ ...card, id: Math.random() }));

              setChoiceOne(null);
              setChoiceTwo(null);
              // update the states
              setCards(shuffledCards);
              setTurns(0)
    }

    // handle user selection choice
    const handleChoice = (card) => {
        // update either choiceOne or choiceTwo
        // if choiceOne is not null, there already exists a value, update choiceTwo
        choiceOne ? setChoiceTwo(card) : setChoiceOne(card)
    }

    // compare the 2 selected cards
    useEffect(() => {
        // do comparison when function runs and there are 2 selections
        if (choiceOne && choiceTwo) {
            setDisabled(true);
            // src of choiceOne == choiceTwo
            if (choiceOne.src === choiceTwo.src) {
                // update the card state, take in previous card state
                setCards(previousCard => {
                    // return a new array of cards based on previousCard
                    // run a function for each card, each time return the object to be placed in array
                    return previousCard.map(card => {
                        // if match
                        if (card.src === choiceOne.src) {
                            setCount(preCount => preCount + 1)
                            if (count === 10) {
                                if (turns < 15) {
                                    setTimeout(() => {
                                        if (!givenCode) {
                                            // access backend to post a new discount code
                                            axios.post(`${CommonVars.API_URL}/user/${userid}/discount-code`, {}, { headers: { Authorization: `Bearer ${theToken}` } })
                                            .then(() => {
                                                if (!gameToast.isActive(id)) {
                                                    gameToast({
                                                        id,
                                                        title: 'Congratulations!',
                                                        description: "You have earned discount codes!",
                                                        status: 'success',
                                                        position: 'top',
                                                        duration: 3000,
                                                        isClosable: true,
                                                    })
                                                }
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                            });
                                            
                                        }
                                        givenCode = true;
                                    }, 400)
                                } else {
                                    setTimeout(() => {
                                        if (!gameToast.isActive(id)) {
                                            gameToast({
                                                id,
                                                title: "Don't Give Up!",
                                                description: "Try again, get better at it!",
                                                status: 'info',
                                                position: 'top',
                                                duration: 3000,
                                                isClosable: true,
                                            })
                                        }
                                    }, 600);
                                }
                            }
                            return ({ ...card, matched: true })
                        } else {
                            // don't match
                            // no need to change anything
                            return card
                        }
                    });
                });
                // once comparison done, call turnReset
                turnReset();
            } else {
                // don't match
                // reset the turn
                // set a timeout
                setTimeout(() => {
                    turnReset();
                }, 1000)
            }
        }
    }, [choiceOne, choiceTwo, count, turns, gameToast, theToken, userid]);

    // reset the choices and increase turns after a choice comparison
    const turnReset = () => {
        setChoiceOne(null);
        setChoiceTwo(null);
        setTurns(previousTurn => previousTurn + 1);
        setDisabled(false);
    }

    // start the game automatically when user lands on screen
    useEffect(() => {
        shuffleCards();
    }, []);

    return (
        <Flex 
            minH={'100vh'}
            justify={'center'}
            bg={'#F4F4F4'}
        >
            <Box align={'center'} pt={10} pb={10}>
                <Heading pb={2}>Earn Discount Codes!</Heading>
                <Text pb={5}>Complete this memory game within 15 turns to win.</Text>
                <Button colorScheme={'blue'} onClick={shuffleCardsReload} variant={'outline'}>Restart Game</Button>
                <Text pt={5} fontSize={20} fontWeight={'bold'}>Turns: {turns}</Text>

                <Box className="card-grid">
                    {cards.map(card => (
                        <SingleCard 
                            key={card.id} 
                            card={card}
                            handleChoice={handleChoice}
                            flipped={card === choiceOne || card === choiceTwo || card.matched}
                            disabled={disabled}
                        />
                    ))}
                </Box>
            </Box>
        </Flex>
    );
}

export default MemoryGameScreen;